import { motion } from 'framer-motion';
import RunawayButton from '../components/RunawayButton';
import '../styles/templates.css';

const FloatingHearts = () => (
  <div className="floating-anniversary">
    {[...Array(15)].map((_, i) => (
      <motion.div
        key={i}
        className="anniversary-float"
        initial={{ y: '100vh', x: `${Math.random() * 100}vw`, opacity: 0 }}
        animate={{
          y: '-10vh',
          opacity: [0, 1, 1, 0],
        }}
        transition={{
          duration: 5 + Math.random() * 3,
          repeat: Infinity,
          delay: Math.random() * 5,
          ease: 'linear',
        }}
      >
        {['\uD83D\uDC91', '\uD83D\uDC95', '\uD83E\uDD42', '\u2728', '\uD83D\uDC96'][Math.floor(Math.random() * 5)]}
      </motion.div>
    ))}
  </div>
);

const AnniversaryTemplate = ({ question, onYes, showCta, cta, patternStyle = {} }) => {
  if (showCta) {
    return (
      <motion.div
        className="template anniversary-template cta-view"
        initial={{ rotateY: 90 }}
        animate={{ rotateY: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="pattern-overlay" style={patternStyle} />
        <FloatingHearts />
        <div className="cta-content">
          <motion.div
            className="success-icon"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 1 }}
          >
            {'\uD83E\uDD42'}
          </motion.div>
          <h1>To Us!</h1>
          <p className="cta-text">{cta}</p>
          <motion.div
            className="confetti"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {'\uD83D\uDC95\uD83E\uDD42\uD83D\uDC91\uD83E\uDD42\uD83D\uDC95'}
          </motion.div>
        </div>
      </motion.div>
    );
  }

  return (
    <div className="template anniversary-template">
      <div className="pattern-overlay" style={patternStyle} />
      <FloatingHearts />
      <div className="template-content">
        <motion.div
          className="anniversary-icon"
          animate={{
            scale: [1, 1.1, 1],
            rotate: [0, 5, -5, 0],
          }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          {'\uD83D\uDC91'}
        </motion.div>

        <motion.h1
          className="invite-question"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {question}
        </motion.h1>

        <div className="button-container">
          <motion.button
            className="yes-button anniversary-yes"
            onClick={onYes}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Yes, Always! {'\uD83D\uDC95'}
          </motion.button>
        </div>
      </div>

      <RunawayButton className="anniversary-no">
        Not tonight...
      </RunawayButton>
    </div>
  );
};

export default AnniversaryTemplate;
